export const shadows = [
  'none',
  '0px 1px 3px 0px rgba(0, 0, 0, 0.12), 0px 1px 1px 0px rgba(0, 0, 0, 0.14), 0px 2px 1px -1px rgba(0, 0, 0, 0.20)',
  '0 0 1px 0 rgba(0,0,0,0.5), 0 2px 3px -2px rgba(0,0,0,0.4)',
  '0 0 1px 0 rgba(0,0,0,0.5), 0 3px 4px -2px rgba(0,0,0,0.4)',
  '0 0 1px 0 rgba(0,0,0,0.5), 0 3px 4px -2px rgba(0,0,0,0.4)',
  '0 0 1px 0 rgba(0,0,0,0.5), 0 4px 6px -2px rgba(0,0,0,0.4)',
  '0 0 1px 0 rgba(0,0,0,0.5), 0 4px 6px -2px rgba(0,0,0,0.4)',
  '0 0 1px 0 rgba(0,0,0,0.5), 0 4px 8px -2px rgba(0,0,0,0.4)',
  '0 0 1px 0 rgba(0,0,0,0.5), 0 5px 10px -3px rgba(0,0,0,0.4)',
  '0 0 1px 0 rgba(0,0,0,0.5), 0 6px 12px -4px rgba(0,0,0,0.4)',
  '0 0 1px 0 rgba(0,0,0,0.5), 0 7px 12px -4px rgba(0,0,0,0.4)',
  '0 0 1px 0 rgba(0,0,0,0.5), 0 6px 16px -4px rgba(0,0,0,0.4)',
  '0 0 1px 0 rgba(0,0,0,0.5), 0 7px 16px -4px rgba(0,0,0,0.4)',
  '0 0 1px 0 rgba(0,0,0,0.5), 0 8px 18px -8px rgba(0,0,0,0.4)',
  '0 0 1px 0 rgba(0,0,0,0.5), 0 9px 18px -8px rgba(0,0,0,0.4)',
  '0 0 1px 0 rgba(0,0,0,0.5), 0 10px 20px -8px rgba(0,0,0,0.4)',
  '0 0 1px 0 rgba(0,0,0,0.5), 0 11px 20px -8px rgba(0,0,0,0.4)',
  '0 0 1px 0 rgba(0,0,0,0.5), 0 12px 22px -8px rgba(0,0,0,0.4)',
  '0 0 1px 0 rgba(0,0,0,0.5), 0 13px 22px -8px rgba(0,0,0,0.4)',
  '0 0 1px 0 rgba(0,0,0,0.5), 0 14px 24px -8px rgba(0,0,0,0.4)',
  '0 0 1px 0 rgba(0,0,0,0.5), 0 16px 28px -8px rgba(0,0,0,0.4)',
  '0 0 1px 0 rgba(0,0,0,0.5), 0 18px 30px -8px rgba(0,0,0,0.4)',
  '0 0 1px 0 rgba(0,0,0,0.5), 0 20px 32px -8px rgba(0,0,0,0.4)',
  '0 0 1px 0 rgba(0,0,0,0.5), 0 22px 34px -8px rgba(0,0,0,0.4)',
  '0 0 1px 0 rgba(0,0,0,0.5), 0 24px 36px -8px rgba(0,0,0,0.4)',
];
